import { render, staticRenderFns } from "./masterPh.vue?vue&type=template&id=0f17275c&scoped=true&"
import script from "./masterPh.vue?vue&type=script&lang=js&"
export * from "./masterPh.vue?vue&type=script&lang=js&"
import style0 from "./masterPh.vue?vue&type=style&index=0&id=0f17275c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f17275c",
  null
  
)

export default component.exports